import React from "react";
import Lottie from "lottie-react";
import loadingAnim from "../assets/your_lottie_loader.json"; // Replace with your file path

const Loader = () => {
    return (
        <div className="fixed inset-0 bg-black flex justify-center items-center z-50">
            <div className="w-90 h-90 xl:w-80 xl:h-80">
                <Lottie animationData={loadingAnim} loop autoplay />
            </div>
        </div>
    );
};

export default Loader;
